











































import { Component, Vue, Emit } from 'nuxt-property-decorator'
import Spinner from '@/components/shared/Spinner.vue'

@Component({
  components: {
    Spinner,
  },
})
export default class ModalWrapper extends Vue {
  opened: boolean = false

  mounted() {
    this.opened = true
  }

  beforeDestroy() {
    this.opened = false
  }

  @Emit('onClose')
  onClose(value: boolean) {
    return value
  }
}
